import React, { useState, useEffect, useMemo } from 'react';
import { 
  CheckCircle2, Clock, Loader, GraduationCap, Eye, User, 
  DollarSign, TrendingUp, ClipboardX, RefreshCw, Menu as MenuIcon
} from 'lucide-react';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { formatearFechaCorta, formatearPrecio } from '../../../utils/utils';
import { useUsers } from '../../../metodos/userContext';
import { useisUserAdmin } from '../../../config/unificacion';
import { useNavigate } from 'react-router-dom';


const StatsCard = ({ icon: Icon, label, value, color, bgColor }) => (
  <div className="bg-white p-4 rounded-lg flex items-center">
    <div className={`p-3 rounded-full ${bgColor}`}>
      <Icon size={24} className={color} />
    </div>
    <div className="ml-4">
      <p className="text-sm text-slate-500">{label}</p>
      <span className="text-2xl font-bold text-slate-800">{value}</span>
      <p className="text-xs text-slate-400">servicios</p>
    </div>
  </div>
);

  //admin view
const AdminView = ({ servicio }) => {
    const ganancia = servicio.preciocobrado - servicio.preciotutor;
    return (
        <div className="space-y-5">
            {/* --- Métricas Financieras --- */}
            <div>
                <p className="text-sm font-bold text-gray-500 mb-2 tracking-wider">MÉTRICAS FINANCIERAS</p>
                <div className="grid grid-cols-3 gap-2 text-center">
                    <div className="bg-gray-100 p-2 rounded-lg">
                        <p className="text-xs text-gray-600">Servicio</p>
                        <p className="font-bold text-gray-800 text-sm">{formatearPrecio(servicio.preciocobrado)}</p>
                    </div>
                    <div className="bg-gray-100 p-2 rounded-lg">
                        <p className="text-xs text-gray-600">Costo Tutor</p>
                        <p className="font-bold text-gray-800 text-sm">{formatearPrecio(servicio.preciotutor)}</p>
                    </div>
                    <div className="bg-green-100 p-2 rounded-lg">
                        <p className="text-xs text-green-800">Ganancia</p>
                        <p className={`font-bold text-green-700 text-sm ${ganancia < 0 ? 'text-red-600' : ''}`}>
                            {formatearPrecio(ganancia)}
                        </p>
                    </div>
                    <div className="bg-green-100 p-2 rounded-lg">
                        <p className="text-xs text-green-800">Referido Por</p>
                        <p className={`font-bold text-green-700 text-sm ${ganancia < 0 ? 'text-red-600' : ''}`}>
                            {formatearPrecio(servicio.gananciaReferido)}
                        </p>
                    </div>
                </div>
            </div>
            {/* --- Involucrados --- */}
            <div>
                 <p className="text-sm font-bold text-gray-500 mb-2 tracking-wider">INVOLUCRADOS</p>
                 <div className="text-sm space-y-1">
                     <p className="flex items-center gap-2 text-gray-700"><User size={14} /> Cliente: <span className="font-medium">{servicio.cliente}</span></p>
                     <p className="flex items-center gap-2 text-gray-700"><GraduationCap size={14} /> Tutor: <span className="font-medium">{servicio.tutor}</span></p>
                      <p className="flex items-center gap-2 text-gray-700"><GraduationCap size={14} /> Referido: <span className="font-medium">{servicio.referidoPor}</span></p>
                 </div>
            </div>
        </div>
    );
}

  //tutor viewn
const TutorView = ({ servicio }) => {
    return (
        <div>
            <p className="text-sm font-bold text-gray-500 mb-2 tracking-wider">DETALLES DE TU TAREA</p>
            <div className="space-y-2">
                {/* --- CODIGO --- */}
                <div className="flex items-center justify-between bg-gray-100 p-3 rounded-lg">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                        <DollarSign size={16} />
                        <span>Codigo</span>
                    </div>
                    <span className="font-bold text-lg text-green-600">{servicio.codigo}</span>
                </div>
                {/* --- PAGO --- */}
                <div className="flex items-center justify-between bg-gray-100 p-3 rounded-lg">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                        <DollarSign size={16} />
                        <span>Tu Pago</span>
                    </div>
                    <span className="font-bold text-lg text-green-600">{formatearPrecio(servicio.preciotutor)}</span>
                </div>
                {/* --- AVANCE DE ENTREGAS --- */}
                <div className="flex items-center justify-between bg-gray-100 p-3 rounded-lg">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                        <TrendingUp size={16} />
                        <span>Avance Entregas</span>
                    </div>
                    <span className="font-bold text-lg text-indigo-600">{servicio.getAvanceEntregas()}%</span>
                </div>
            </div>
        </div>
    );
}


const TesisItem = ({ servicio , isAdmin = false}) => {
  const progress = servicio.getAvancePagos()|| 0;
  const navigate = useNavigate();
  const statusInfo = isAdmin ? servicio.getAvanceGeneral().admin : servicio.getAvanceGeneral().tutor; // Usamos el de admin como fuente de verdad

  //ver detalles de servicio
  const handleVerServicio = () => {
    navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
  };

  //status
  const StatusAlert = ({}) => (
    <div>
        <p className="text-sm font-bold text-gray-500 mb-2 tracking-wider">{statusInfo}</p>
        <div className={`flex items-start gap-3 p-3 rounded-lg `}>
        </div>
    </div>
  );

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      {/* --- HEADER --- */}
      <div className="p-4 bg-gray-50 border-b border-gray-200">
        <div className="flex justify-between items-center mb-2">
          <h3 className="font-bold text-indigo-700 text-sm md:text-base">{servicio.codigo} #{servicio.idsolicitud}</h3>
          <span className="text-xs text-gray-500 font-medium">{formatearFechaCorta(servicio.fechaentrega) }</span>
        </div>
        <div className="flex items-center gap-3">
            <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div className="bg-indigo-600 h-2.5 rounded-full" style={{ width: `${progress}%` }}></div>
            </div>
            <span className="font-bold text-indigo-700 text-sm">{progress}%</span>
        </div>
      </div>

      {/* --- BODY --- */}
      <div className="p-5 space-y-6">
        <p className="font-bold text-xl text-gray-800">{servicio.materia}</p>
        
        {isAdmin ? (
          <AdminView servicio={servicio} />
        ) : (
          <TutorView servicio={servicio} />
        )}

        <StatusAlert text={servicio.getAvanceGeneral().admin} statusInfo={statusInfo} />
      </div>

      {/* --- FOOTER / ACTION --- */}
      <div className="p-3 bg-gray-50 border-t border-gray-200">
         <button
          onClick={handleVerServicio}
          className="w-full bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors flex items-center justify-center gap-2 text-sm font-semibold"
         >
          <Eye size={16} />
            Ver Detalles del Servicio
        </button>
      </div>
      
    </div>
  );

};

const TesisDashboard = () => {
  const [activeTab, setActiveTab] = useState('En Curso');
  const tabs = ['En Curso', 'Completadas'];
  const {usuario} = useUsers();
  const isAdmin = useisUserAdmin(usuario);
  
  const {servicios,loadingServicios,errorServicios,cargarServicios} = useContabilidadModel();
  

  useEffect(() => {
 
    // La lógica interna no cambia
    if (isAdmin) {
      console.log("Cargando servicios para ADMIN...");
      cargarServicios('', true);
    } else {
      // Aseguramos que 'nombrewhatsapp' exista antes de usarlo
      if (usuario.nombrewhatsapp) {
        console.log(`Cargando servicios para TUTOR: ${usuario.nombrewhatsapp}`);
        cargarServicios(usuario.nombrewhatsapp, false);
      }
    }
    
  // MODIFICACIÓN CLAVE: Cambiamos 'usuario' por 'usuario?.nombrewhatsapp'
  }, [isAdmin, usuario?.nombrewhatsapp]);

  //all services
  const tesis = useMemo(() => (servicios || []).filter(servicio => servicio.materia === 'TESIS'), [servicios]);

  //tesis en cursos y completadas
  const tesisEnCurso = useMemo(() => 
    tesis.filter(t => t.getAvancePagos() < 100), 
    [tesis]
  );
  const tesisCompletadas = useMemo(() => 
    tesis.filter(t => t.getAvancePagos() >= 100), 
    [tesis]
  );

  const tesisAMostrar = activeTab === 'En Curso' ? tesisEnCurso : tesisCompletadas;


  if (loadingServicios) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <Loader className="h-12 w-12 animate-spin text-indigo-600 mx-auto" />
          <p className="mt-4 text-slate-600">Cargando proyectos de tesis...</p>
        </div>
      </div>
    );
  }

  if (errorServicios) {
    return (
      <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-r-lg">
        <h3 className="text-lg font-bold text-red-800">Error al cargar los datos</h3>
        <p className="text-red-700 mt-2">{errorServicios}</p>
        <button
          onClick={() => cargarServicios(true)}
          className="mt-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors flex items-center gap-2"
        >
          <RefreshCw size={16} />
          Reintentar
        </button>
      </div>
    );
  }

  const statsData = [
    { id: 1, label: 'En Curso', value: tesisEnCurso.length, icon: Loader, color: 'text-blue-500', bgColor: 'bg-blue-100' },
    { id: 2, label: 'Completadas', value: tesisCompletadas.length, icon: CheckCircle2, color: 'text-green-500', bgColor: 'bg-green-100' },
    // Esta tarjeta contaba las próximas entregas, la he dejado con una etiqueta más clara.
    { id: 3, label: 'Próximas Entregas', value: tesis.filter(t => new Date(t.fechaentrega) > new Date()).length, icon: Clock, color: 'text-orange-500', bgColor: 'bg-orange-100' },
  ];



  return (
    <div className="p-4 md:p-6 lg:p-8 bg-slate-50 min-h-screen space-y-6">
      {/* --- SECCIÓN DE CABECERA Y TABS --- */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-4">
        <h2 className="text-3xl font-bold text-slate-800">Tesis Manager</h2>
        <div className="bg-white p-1 rounded-full flex items-center space-x-1 shadow-sm">
          {tabs.map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ${ activeTab === tab ? 'bg-indigo-700 text-white shadow-md' : 'text-slate-600 hover:bg-slate-100'}`}>
              {tab}
            </button>
          ))}
        </div>
      </div>
      
      {/* --- SECCIÓN DE ESTADÍSTICAS --- */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {statsData.map((stat) => <StatsCard key={stat.id} {...stat} />)}
      </div>

      {/* --- SECCIÓN DE LA CUADRÍCULA DE TESIS --- */}
      <div>
        <h3 className="text-xl font-bold text-slate-700 mb-4">Proyectos {activeTab}</h3>
        {tesisAMostrar.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg shadow-md">
            <ClipboardX className="h-16 w-16 text-slate-400 mx-auto" />
            <h3 className="mt-4 text-xl font-semibold text-slate-800">No hay proyectos para mostrar</h3>
            <p className="mt-2 text-slate-500">No se encontraron proyectos en la categoría "{activeTab}".</p>
            <button onClick={() => cargarServicios(true)} className="mt-6 bg-indigo-600 text-white px-5 py-2.5 rounded-lg hover:bg-indigo-700 flex items-center gap-2 mx-auto">
              <RefreshCw size={16} /> Actualizar
            </button>
          </div>
        ) : (
          // ⭐ CAMBIO PRINCIPAL: De una lista a una cuadrícula responsive
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {tesisAMostrar.map(item => (
              <TesisItem key={item.id} servicio={item} isAdmin={isAdmin} />
            ))}
          </div>
        )}
      </div>
    </div>
  );

};

export default TesisDashboard;